import type { DeepStrings } from "@rekati/i18n";
import type { Dict } from "./en";

export const id: DeepStrings<Dict> = {
  meta: { skip: "Lewati ke konten", language: "Bahasa", poweredBy: "Didukung oleh" },
  login: {
    kicker: "Konsol staf",
    title: "Masuk",
    body: "Untuk meja registrasi, layar live, dan penyelenggara.",
    login: "Login",
    password: "Kata sandi",
    show: "Tampilkan kata sandi",
    hide: "Sembunyikan kata sandi",
    submit: "Masuk",
    invalid: "Login dan kata sandi tidak cocok.",
  },
  areas: {
    scan: "Pindai QR",
    lookup: "Cari nama",
    "walk-in": "Walk-in",
    board: "Layar live",
    overview: "Ringkasan",
    attendees: "Peserta",
    sessions: "Sesi",
    demographics: "Profil peserta",
    users: "Pengguna",
    event: "Acara",
    activities: "Aktivitas",
    content: "Konten",
    email: "Email",
    survey: "Survei",
  },
  groups: { door: "Pintu masuk", live: "Live", numbers: "Angka", manage: "Kelola" },
  shell: {
    menu: "Menu",
    close: "Tutup",
    signOut: "Keluar",
    collapse: "Ciutkan menu",
    expand: "Lebarkan menu",
    signedInAs: "Masuk sebagai {name}",
    lane: "Jalur",
  },
  common: { save: "Simpan", cancel: "Batal", optional: "(opsional)", yes: "Ya", no: "Tidak" },
  identity: {
    brand_owner: "Pemilik brand",
    creative_worker: "Pekerja kreatif",
    professional: "Profesional",
  },
  errors: {
    generic: "Terjadi kesalahan. Silakan coba lagi.",
    network: "Server tidak dapat dihubungi. Periksa koneksi.",
    forbidden: "Halaman ini bukan untuk login ini.",
    sessionExpired: "Sesi Anda berakhir. Silakan masuk lagi.",
    rateLimited: "Terlalu banyak percobaan. Tunggu {s} detik.",
    eventNotConfigured: "Acara belum disiapkan di server.",
    validation: "Ada isian yang tidak valid. Periksa kolomnya.",
    retry: "Coba lagi",
  },
  fields: {
    required: "Wajib diisi.",
    tooLong: "Terlalu panjang.",
    tooShort: "Terlalu pendek.",
    invalid: "Isian ini tidak sesuai.",
    email: "Masukkan alamat email yang valid.",
    phone: "Masukkan nomor HP Indonesia, misalnya 0812…",
    emailTaken: "Email ini sudah dipakai akun lain.",
    phoneTaken: "Nomor HP ini sudah dipakai akun lain.",
    notApplicable: "Tidak berlaku untuk pilihan ini.",
  },
  notFound: { title: "Halaman ini tidak ada", home: "Ke halaman utama saya" },

  door: {
    walkInBadge: "Walk-in",
    verdict: {
      in: "Silakan masuk",
      again: "Sudah di dalam: persilakan lewat",
      againSince: "Check-in pukul {time} di {lane} oleh {by}.",
      queued: "Disimpan di perangkat ini",
      queuedBody:
        "Server tidak menjawab. Pindaian disimpan di sini dan dikirim begitu koneksi kembali. Persilakan masuk.",
      unknown: "QR tidak dikenal",
      unknownBody: "Kode ini bukan tiket peserta. Cari orangnya lewat nama:",
      error: "Tidak bisa memeriksa yang ini",
      merch: "Berikan merchandise",
      merchAgain: "Sudah diambil: jangan berikan lagi",
      merchAgainSince: "Diambil pukul {time} di {lane} dari {by}.",
    },
    log: {
      in: "Check-in",
      again: "Sudah di dalam",
      queued: "Disimpan offline",
      unknown: "QR tidak dikenal",
      error: "Gagal",
      merch: "Merchandise diberikan",
      merchAgain: "Merchandise sudah diambil",
    },
    merch: {
      offline:
        "Tidak ada koneksi: QR merchandise perlu dicek ke server. Tunggu koneksi kembali, lalu pindai lagi; jangan berikan merchandise dulu.",
      notFound: "Bukan QR merchandise. Minta QR dari halaman survei (iforte.rekati.com/survey).",
    },
    queue: {
      waiting: "{n} menunggu dikirim",
      sent: "{n} pindaian offline terkirim",
      partial: "{sent} terkirim, {kept} masih menunggu",
    },
    camera: {
      label: "Tampilan kamera",
      starting: "Menyalakan kamera…",
      denied: "Akses kamera diblokir. Izinkan di pengaturan situs browser, atau pakai kolom di bawah.",
      none: "Tidak ada kamera di perangkat ini. Pakai scanner genggam atau kolom di bawah.",
      insecure: "Kamera butuh alamat aman (https). Sementara pakai kolom di bawah.",
      failed: "Kamera tidak bisa menyala. Pakai kolom di bawah.",
      switch: "Ganti kamera",
    },
    scan: {
      body: "Arahkan kamera ke tiket. Scanner genggam mengetik ke kolom di bawah.",
      manual: "Scanner atau kode",
      manualHint: "Scanner genggam mengetik kodenya dan menekan Enter sendiri.",
      send: "Periksa",
      waiting: "Menunggu kode QR…",
      recent: "Di perangkat ini",
      noneYet: "Belum ada yang dipindai.",
    },
    lookup: {
      body: "Untuk QR yang hilang atau tidak terbaca. Cari lewat nama atau 4 digit terakhir nomor HP.",
      label: "Nama atau 4 digit terakhir",
      placeholder: "Nama, atau 4 digit terakhir HP",
      hint: "Ketik minimal dua huruf nama, atau tepat empat angka.",
      tooBroad: "Terlalu banyak yang cocok. Ketik nama lebih lengkap.",
      none: "Tidak ada yang cocok. Periksa ejaannya, atau daftarkan sebagai walk-in.",
      capped: "Menampilkan 25 pertama. Ketik lebih lengkap untuk mempersempit.",
      in: "Sudah di dalam",
      inSince: "Di dalam sejak {time}",
      admit: "Izinkan masuk",
    },
    walkIn: {
      body: "Daftarkan orang di meja dan langsung izinkan masuk. Tidak ada email yang dikirim.",
      who: "Siapa",
      name: "Nama lengkap",
      email: "Email",
      phone: "Nomor HP",
      phoneHint: "Diawali 08, 62, atau +62.",
      phoneAs: "Akan disimpan sebagai {phone}",
      lang: "Bahasa untuk email berikutnya",
      langHint: "Dipakai untuk email apa pun setelah acara.",
      profile: "Profil",
      profileBody: "Opsional. Biarkan jenisnya kosong untuk melewati profil.",
      identity: "Jenis",
      identityNone: "Lewati profil",
      company: "Instansi / perusahaan",
      brand: "Nama brand",
      jobTitle: "Jabatan",
      industry: "Industri",
      industryOther: "Lainnya…",
      industryOtherLabel: "Industri apa",
      submit: "Daftarkan dan izinkan masuk",
      saving: "Menyimpan…",
      note: "Nomor HP yang sudah terdaftar langsung mengizinkan orang itu masuk.",
    },
  },

  board: {
    checkedIn: "Sudah hadir",
    ofRegistered: "dari {n} terdaftar · {share}%",
    walkIns: "{n} walk-in",
    perHour: "Kedatangan per jam",
    recent: "Baru tiba",
    none: "Kedatangan akan muncul di sini.",
    fullscreen: "Layar penuh",
    toConsole: "Kembali ke konsol",
    exitFullscreen: "Keluar layar penuh",
  },

  numbers: {
    overviewBody: "Angka utama, langsung dari pintu masuk.",
    asOf: "Angka per {time}, diperbarui langsung.",
    checkedIn: "Sudah hadir",
    ofRegistered: "{share} dari yang terdaftar",
    registered: "Terdaftar",
    registeredNote: "Email terkonfirmasi",
    profiles: "Profil lengkap",
    submitted: "Paket terkirim",
    noShow: "Belum datang",
    noShowNote: "Terdaftar, belum check-in",
    walkIns: "Walk-in",
    walkInsNote: "Didaftarkan di meja",
    arrivalsTitle: "Kedatangan per jam",
    arrivalsBody: "Check-in di hari acara, waktu Jakarta.",
    noArrivals: "Belum ada check-in.",
    registrationsTitle: "Registrasi per hari",
    registrationsBody: "Registrasi terkonfirmasi; walk-in dihitung terpisah.",
    noRegistrations: "Belum ada registrasi terkonfirmasi.",
  },

  export: {
    label: "Ekspor",
    working: "Menyiapkan…",
    xlsx: "Laporan Excel",
    xlsxBody: "Ringkasan, grafik, dan daftar peserta lengkap.",
    csv: "Daftar CSV",
    csvBody: "Daftar peserta, beserta jawaban survei setelah survei berjalan.",
    surveyXlsx: "Excel survei",
    surveyXlsxBody: "Satu baris per jawaban, dengan filter di setiap kolom.",
    surveyCsv: "CSV survei",
    surveyCsvBody: "Hanya jawaban survei, satu baris per peserta.",
    done: "Unduhan siap",
  },

  sessions: {
    body: "Seberapa penuh tiap aktivitas, dan berapa pemegang tempat yang datang.",
    none: "Tidak ada sesi. Acara ini tidak memakai pemesanan sesi.",
    title: "Sesi",
    when: "Waktu",
    capacity: "Kapasitas",
    confirmed: "Terkonfirmasi",
    waitlisted: "Daftar tunggu",
    checkedIn: "Datang",
    showUp: "Kehadiran",
    count: "Sesi",
    cameOf: "{n} dari {of} datang",
    allDay: "Sepanjang hari",
    tbd: "Belum ditentukan",
    full: "Penuh",
  },

  demographics: {
    body: "Siapa yang mendaftar, dari profil mereka.",
    identity: "Jenis",
    registration: "Cara daftar",
    industry: "Industri",
    howHeard: "Tahu dari mana",
    none: "Tidak dijawab",
    other: "lainnya",
    online: "Online",
    onSite: "Di meja",
    empty: "Belum ada jawaban.",
  },

  attendees: {
    body: "Semua yang terdaftar, terbaru di atas. Data kontak hanya untuk penyelenggara.",
    search: "Cari nama, email, atau HP",
    count: "{n} orang",
    none: "Belum ada yang mendaftar.",
    noMatch: "Tidak ada yang cocok dengan pencarian atau filter itu.",
    filterCheckIn: "Check-in",
    filterRegistration: "Pendaftaran",
    filterAll: "Semua",
    filterIn: "Sudah check-in",
    filterNotIn: "Belum check-in",
    filterOnline: "Online, terkonfirmasi",
    filterUnverified: "Online, belum verifikasi",
    filterWalkIn: "Walk-in",
    name: "Nama",
    org: "Instansi / brand",
    registered: "Terdaftar",
    status: "Status",
    email: "Email",
    phone: "HP",
    identity: "Jenis",
    jobTitle: "Jabatan",
    industry: "Industri",
    community: "Anggota komunitas",
    verified: "Email terkonfirmasi",
    packSent: "Paket terkirim",
    checkedIn: "Check-in",
    unverified: "Belum verifikasi",
    walkIn: "Walk-in",
    inAt: "Masuk {time}",
    pages: "Halaman",
    page: "Halaman {page} dari {pages}",
    prev: "Sebelumnya",
    next: "Berikutnya",
    adminNote: "Koreksi data peserta dilakukan oleh superuser.",
  },

  record: {
    gone: "Peserta ini sudah tidak ada.",
    contact: "Kontak",
    edit: "Koreksi",
    editBody:
      "Perbaiki nama, email, atau HP yang salah ketik. Memperbaiki email orang yang masih menunggu kode akan mengirim kode ke alamat baru.",
    fields: { full_name: "Nama lengkap", email: "Email", phone: "Nomor HP" },
    saved: "Tersimpan",
    codeResent: "Kode baru dikirim ke {email}.",
    verification: {
      active: "Kode terkirim, menunggu",
      expired: "Kode kedaluwarsa",
      locked: "Kode terkunci karena terlalu banyak percobaan",
    },
    optOut: "Berhenti berlangganan",
    profile: "Profil",
    noProfile: "Belum ada profil.",
    consent: "Persetujuan",
    checkIn: "Check-in",
    checkedInLine: "Masuk {time}, {lane}, oleh {by}.",
    notIn: "Belum check-in.",
    checkInNow: "Check in",
    checkedInNow: "{name} sudah check-in",
    alreadyIn: "Sudah check-in pukul {time}",
    inAtShort: "Check-in {time}",
    undo: "Batalkan check-in",
    undoTitle: "Batalkan check-in ini?",
    undoBody:
      "Untuk salah pindai atau walk-in yang keliru diizinkan. Daftar di layar live tidak berubah; totalnya akan menyesuaikan sendiri.",
    undoConfirm: "Batalkan",
    undone: "Check-in dihapus",
    notCheckedIn: "Orang ini belum check-in.",
    confirmed: "Terkonfirmasi",
    waitlist: "Daftar tunggu #{n}",
    release: "Lepaskan",
    released: "Tempat dilepaskan",
    promoted: "Orang berikutnya di daftar tunggu mendapat tempatnya.",
    bookLabel: "Pesan sesi…",
    book: "Pesan",
    join: {
      confirmed: "Dipesan",
      waitlisted: "Sesi penuh: masuk daftar tunggu",
      already: "Sudah memegang sesi ini",
    },
    rsvpDisabled: "Pemesanan sesi dimatikan untuk acara ini.",
    sessionCancelled: "Sesi itu dibatalkan.",
    capacityNotSet: "Sesi itu belum punya kapasitas.",
    email: "Email",
    resendCode: "Kirim ulang kode",
    codeSent: "Kode terkirim",
    codeUntil: "Berlaku sampai {time}.",
    alreadyVerified: "Sudah terverifikasi.",
    noCodeInFlight: "Tidak ada kode yang menunggu. Mereka bisa mendaftar lagi dengan nomor yang sama.",
    resendPack: "Kirim ulang paket",
    packQueued: "Paket diantrekan",
    packAlready: "Paket sudah dalam perjalanan",
    notVerified: "Email mereka belum terkonfirmasi.",
    profileIncomplete: "Profil mereka belum lengkap, jadi belum ada paket untuk dikirim.",
    delete: "Hapus peserta",
    deleteTitle: "Hapus peserta ini?",
    deleteBody:
      "Melepas tempat mereka, menghapus check-in, dan membatalkan email yang antre. Nomor HP dan email tetap terpakai. Hanya operator di database yang bisa membatalkannya.",
    deleteConfirm: "Hapus",
    deleted: "Peserta dihapus",
  },

  profileEdit: {
    open: "Ubah profil",
    body: "Pertanyaan dan aturan yang sama dengan formulir registrasi. Yang wajib ditandai *.",
    save: "Simpan profil",
    saved: "Profil tersimpan",
    savedBody: "Tidak ada email yang dikirim; pakai Kirim ulang paket jika peserta masih membutuhkannya.",
    required: "wajib",
    noConsentTitle: "Persetujuan hanya bisa diberikan peserta",
    noConsentBody:
      "Profil ini disimpan tanpa persetujuan peserta (di meja registrasi). Profil bisa diubah di sini setelah peserta menyetujuinya sendiri di halaman /rsvp.",
    noProfileBody: "Belum ada profil. Peserta mengisinya sendiri, dengan persetujuannya, di halaman /rsvp.",
    identityChange: "Mengganti jenis akan menghapus jawaban yang hanya berlaku untuk jenis lama.",
    interestOther: "Minat lainnya",
    blankKeeps: "Kolom yang dikosongkan tetap menyimpan jawaban lama; jawabannya tidak terhapus.",
    missing: "{n} pertanyaan wajib belum dijawab.",
    q: {
      identity_type: "Jenis",
      personal_instagram: "Instagram pribadi",
      how_heard: "Tahu acara dari mana",
      what_excites_you: "Yang membuat tertarik",
      industry: "Industri",
      interests: "Minat",
      brand_name: "Nama brand",
      about_brand: "Tentang brand",
      brand_instagram: "Instagram brand",
      company_name: "Instansi / perusahaan",
      job_title: "Jabatan",
      community_member: "Anggota {community}",
      community_member_plain: "Anggota komunitas",
    },
  },
  kara: {
    launch: "Tanya Kara",
    online: "Online",
    offline: "Offline",
    unset: "Belum aktif",
    unsetHint: "Kara belum diaktifkan di server ini.",
    offlineHint: "Kara sedang offline",
    intro:
      "Tanyakan soal registrasi, kehadiran, dan lineup. Kara menjawab dengan angka, bukan data peserta perorangan.",
    try1: "Berapa orang yang sudah check-in?",
    try2: "Registrasi per hari minggu ini?",
    try3: "Berapa persen pendaftar yang profesional?",
    ask: "Tanya Kara…",
    send: "Kirim",
    thinking: "Kara sedang berpikir…",
    consulted: "memeriksa: {tools}",
    restart: "Percakapan baru",
    unavailable: "Kara sedang offline. Coba lagi sebentar lagi.",
  },

  users: {
    body: "Login untuk perangkat meja, layar live, dan penyelenggara.",
    add: "Tambah login",
    addBody: "Perangkat meja memakai login biasa seperti frontdesk_7; orang memakai email.",
    none: "Belum ada login.",
    you: "Anda",
    active: "Aktif",
    inactive: "Nonaktif",
    activeFor: "{name} bisa masuk",
    role: "Peran untuk {name}",
    roleLabel: "Peran",
    roleHint: {
      frontdesk: "Meja: pindai, cari nama, walk-in.",
      monitor: "Layar live dan angka utama.",
      admin: "Semua angka, daftar peserta, ekspor, dan Kara.",
      superuser: "Semuanya, ditambah halaman pengelolaan ini.",
    },
    more: "Lainnya untuk {name}",
    lastLogin: "Terakhir masuk {time}",
    neverLoggedIn: "Belum pernah masuk",
    reset: "Atur ulang kata sandi",
    revoke: "Keluarkan dari semua perangkat",
    revoked: "{name} dikeluarkan dari semua perangkat",
    updated: "{name} diperbarui",
    selfChange: "Anda tidak bisa mengubah peran sendiri atau menonaktifkan diri. Minta superuser lain.",
    notFound: "Login itu sudah tidak ada.",
    login: "Login",
    loginHint: "Huruf kecil; frontdesk_7 atau email.",
    loginTaken: "Login itu sudah ada.",
    name: "Nama",
    password: "Kata sandi",
    passwordHint: "Minimal 12 karakter. Kosongkan untuk dibuatkan.",
    passwordShort: "Minimal 12 karakter.",
    create: "Buat login",
    created: "{name} dibuat",
    secretTitle: "Kata sandi untuk {name}",
    secretBody:
      "Hanya ditampilkan sekali. Salin sekarang: tidak bisa ditampilkan lagi, hanya bisa diatur ulang.",
    copy: "Salin",
    copied: "Tersalin",
    secretDone: "Sudah saya simpan",
  },

  event: {
    body: "Nama acara, jadwal, dan detail yang diterima peserta.",
    basics: "Dasar",
    name: "Nama acara",
    date: "Tanggal acara",
    deadline: "Pemesanan sesi ditutup",
    deadlineHint: "Kosong berarti tidak pernah ditutup.",
    starts: "Pintu dibuka",
    ends: "Selesai",
    rsvp: "Pemesanan sesi",
    rsvpHint: "Matikan untuk acara tanpa sesi yang dipesan.",
    words: "Yang dibaca peserta",
    wordsBody: "Dipakai di email, paket, dan situs.",
    variantAll: "Semua",
    variantAllHint: "Teks bawaan, untuk semua bahasa.",
    variantIdHint: "Khusus pembaca bahasa Indonesia. Kosong memakai teks bawaan.",
    variantEnHint: "Khusus pembaca bahasa Inggris. Kosong memakai teks bawaan.",
    links: "Tautan dan kontak",
    roles: "Nama peran",
    rolesBody: "Sebutan penyelenggara untuk tiap peran staf.",
    form: "Formulir registrasi",
    formBody: "Pertanyaan profil yang ditanyakan. Ubah hanya bersama tim.",
    hints: {
      profile_required: "Kunci pertanyaan dipisah koma, misalnya company_name, job_title.",
      profile_identity:
        "Jenis untuk semua orang saat formulir tidak menanyakannya: professional, creative_worker, atau brand_owner.",
      community_name: "Komunitas di pertanyaan keanggotaan, misalnya Komitkabe.",
    },
    keys: {
      venue_name: "Tempat",
      venue_address: "Alamat tempat",
      venue_map_url: "Tautan peta",
      parking: "Parkir",
      dress_code: "Dress code",
      how_it_works: "Cara kerja",
      qr_instructions: "Petunjuk QR",
      before_you_come: "Sebelum datang",
      event_guidelines: "Panduan acara (satu per baris)",
      photo_link: "Tautan foto",
      survey_url: "Tautan survei",
      sponsor_offers: "Penawaran sponsor",
      organizer_name: "Penyelenggara",
      powered_by_name: "Didukung oleh",
      contact_name: "Nama kontak",
      contact_phone: "Telepon kontak",
      role_label_frontdesk: "Peran meja",
      role_label_monitor: "Peran layar",
      role_label_admin: "Peran admin",
      role_label_superuser: "Peran superuser",
      rsvp_enabled: "Pemesanan sesi",
      profile_required: "Pertanyaan wajib",
      profile_identity: "Jenis bawaan",
      community_name: "Nama komunitas",
    },
    unsaved: "{n} perubahan belum disimpan",
    allSaved: "Semua sudah tersimpan",
    discard: "Buang",
    saved: "Acara tersimpan",
  },

  activities: {
    body: "Lineup acara. Membatalkan tetap menyimpan semua pemesanan dan tidak menerima yang baru.",
    add: "Tambah aktivitas",
    none: "Belum ada aktivitas.",
    rsvpOff: "Pemesanan sesi dimatikan",
    rsvpOffBody: "Aktivitas tetap tampil, tapi tidak bisa dipesan sampai pemesanan dinyalakan di Acara.",
    cancelledBadge: "Dibatalkan",
    noCapacity: "Tanpa kapasitas",
    fill: "{confirmed}/{capacity} terkonfirmasi · {waitlisted} menunggu",
    edit: "Ubah",
    cancel: "Batalkan aktivitas",
    reinstate: "Aktifkan lagi",
    cancelled: "{title} dibatalkan",
    reinstated: "{title} diaktifkan lagi",
    editTitle: "Ubah aktivitas",
    dialogBody: "Waktu dalam WIB (Jakarta).",
    saved: "{title} tersimpan",
    slugTaken: "Slug ini sudah dipakai aktivitas lain.",
    belowConfirmed: "Tidak boleh di bawah {n} yang sudah terkonfirmasi.",
    poster: "Poster",
    posterHint: "PNG, JPEG, atau WebP, maksimal 1 MB. Dipakai saat tidak ada tautan sampul.",
    upload: "Unggah poster",
    removePoster: "Hapus poster",
    posterSaved: "Poster tersimpan",
    posterRemoved: "Poster dihapus",
    f: {
      title: "Judul",
      slug: "Slug",
      slugHint: "Huruf kecil dan tanda hubung, misalnya panel-1.",
      host: "Penyelenggara sesi",
      room: "Ruangan",
      allDayHint: "Tanpa slot dan tanpa kapasitas",
      starts: "Mulai",
      ends: "Selesai",
      capacity: "Kapasitas",
      capacityHint: "Kosong membuatnya tertutup untuk pemesanan.",
      cover: "Tautan gambar sampul",
      coverHint: "Alamat https:// sebuah gambar.",
      description: "Deskripsi",
      highlights: "Sorotan",
      highlightsHint: "Satu paragraf per sorotan; baris pertama adalah judulnya.",
    },
  },

  content: {
    body: "Logo dan daftar pilihan di formulir registrasi.",
    logos: "Logo",
    logosBody:
      "PNG atau JPEG, maksimal 1 MB. Logo yang diganti bisa butuh hingga satu jam untuk tampil di mana-mana.",
    industries: "Industri",
    industriesBody:
      "Jika dimatikan, industri disembunyikan dari formulir; profil yang sudah memilihnya tetap menyimpannya.",
    interests: "Minat",
    interestsBody: "Minat unggulan tampil paling atas di formulir.",
    slots: {
      organizer_logo: "Penyelenggara",
      organizer_logo_dark: "Penyelenggara, latar gelap",
      powered_by_logo: "Didukung oleh",
      powered_by_logo_dark: "Didukung oleh, latar gelap",
      platform_logo: "Platform",
      platform_logo_dark: "Platform, latar gelap",
    },
    noFile: "Belum ada file",
    slotHint: "Belum diunggah",
    upload: "Unggah",
    uploadFor: "Unggah {slot}",
    replace: "Ganti",
    remove: "Hapus",
    uploaded: "Logo terunggah",
    removed: "Logo dihapus",
    tooBig: "File lebih dari 1 MB.",
    wrongType: "File itu bukan gambar PNG atau JPEG.",
    newLabel: "Item baru",
    add: "Tambah",
    labelTaken: "Item itu sudah ada. Nyalakan lagi yang lama.",
    emptyList: "Daftar ini masih kosong.",
    rename: "Nama",
    up: "Naikkan {label}",
    down: "Turunkan {label}",
    featured: "Unggulan",
    active: "Aktif",
    off: "Nonaktif",
  },

  email: {
    body: "Template email, kampanye pengingat dan terima kasih, serta pengiriman yang dijeda.",
    templates: "Template",
    campaigns: "Kampanye",
    holds: "Jeda",
    language: "Bahasa",
    default: "Bawaan",
    pick: "Pilih template untuk mengubahnya.",
    keys: {
      otp: "Kode verifikasi",
      rsvp_pack: "Paket peserta",
      rsvp_updated: "Pemesanan diperbarui",
      rsvp_promoted: "Keluar dari daftar tunggu",
      reminder_h1: "Pengingat, H-1",
      thank_you: "Terima kasih, H+1",
    },
    about: {
      otp: "Kode enam digit saat registrasi dan masuk.",
      rsvp_pack: "Paket berisi QR, dikirim saat profil lengkap.",
      rsvp_updated: "Dikirim saat seseorang mengubah sesinya setelah paket.",
      rsvp_promoted: "Dikirim saat tempat di daftar tunggu terbuka.",
      reminder_h1: "Kampanye sehari sebelum acara, ke semua yang terverifikasi.",
      thank_you: "Kampanye sehari setelah acara, ke semua yang hadir.",
    },
    subject: "Subjek",
    bodyHtml: "Isi (HTML)",
    bodyHint: "Bagian di antara header dan footer bersama. Sisipkan kolom dari daftar di bawah.",
    fullHtml: "Seluruh email (HTML)",
    fullHint: "Versi ini disimpan sebagai email utuh, termasuk header dan footer.",
    fields: "Kolom",
    text: "Versi teks biasa",
    textHint: "Wajib untuk versi email utuh.",
    note: "Catatan",
    save: "Simpan dan pakai",
    saved: "Tersimpan sebagai versi {v}, sekarang dipakai",
    invalid: "Versi ini tidak bisa dirender, jadi tidak disimpan",
    preview: "Pratinjau",
    previewNote:
      "Pratinjau menampilkan versi yang dipakai dengan data contoh; logo sisipan hanya tampil di email asli.",
    test: "Kirim uji coba",
    testHint: "Dirender untuk peserta sungguhan dan dikirim ke alamat yang Anda isi.",
    sendTest: "Kirim uji coba",
    testQueued: "Uji coba diantrekan ke {to}",
    noModel: "Belum ada peserta terverifikasi untuk merender uji coba.",
    newCampaign: "Jadwalkan kampanye",
    newCampaignBody: "Dimulai sebagai draf. Aktifkan saat template dan detailnya siap.",
    kind: "Kampanye",
    when: "Kirim pada (WIB)",
    create: "Buat draf",
    campaignCreated: "Draf dibuat",
    noCampaigns: "Belum ada kampanye.",
    campaignLine: "{when} · {audience} · {n} penerima",
    audience: { verified: "semua yang terverifikasi", checked_in: "semua yang hadir" },
    status: {
      draft: "Draf",
      armed: "Siap kirim",
      sending: "Mengirim",
      paused: "Dijeda",
      sent: "Terkirim",
      cancelled: "Dibatalkan",
    },
    actions: { arm: "Aktifkan", pause: "Jeda", resume: "Lanjutkan", cancel: "Batalkan" },
    progress: "{sent} terkirim · {failed} gagal · dari {of}",
    notReady: "Belum siap diaktifkan",
    badTransition: "Langkah itu tidak bisa dari status kampanye saat ini.",
    holdsBody:
      "Pengiriman berhenti sendiri saat penyedia email terus gagal. Lepaskan jeda setelah penyebabnya beres.",
    noHolds: "Tidak ada yang dijeda.",
    release: "Lepaskan",
    released: "{n} email dilepaskan",
    holdGone: "Jeda itu sudah dilepaskan.",
  },
  survey: {
    body: "Pertanyaan di halaman /survey, dalam dua bahasa. Menyimpan langsung mengubah halaman itu.",
    pageBody: "Hasil, merchandise, dan setiap jawaban; pertanyaan ada di tab kedua.",
    tabs: { results: "Hasil", questions: "Pertanyaan" },
    results: {
      completed: "Jawaban masuk",
      ofCheckedIn: "{share} dari peserta yang check-in",
      collected: "Merchandise diambil",
      ofCompleted: "{share} dari jawaban",
      waiting: "Menunggu merchandise",
      waitingNote: "Sudah mengisi, belum mengambil",
      status: "Survei",
      open: "Dibuka",
      closed: "Ditutup",
      answered: "{n} menjawab",
      several: "boleh pilih lebih dari satu",
      noAnswers: "Belum ada jawaban.",
      average: "rata-rata dari 5",
      score: "{n} dari 5",
      textNote: "Jawaban tertulis: buka salah satu jawaban di bawah, atau ekspor.",
      typedUnder: "Diisi pada \"{option}\"",
      responses: "Daftar jawaban",
      responsesBody: "Terbaru di atas. Buka untuk membaca semua jawaban.",
      filter: "Tampilkan",
      all: "Semua",
      collectedShort: "Sudah diambil",
      waitingShort: "Belum diambil",
      search: "Cari nama, email, telepon, atau institusi",
      showing: "{n} dari {of}",
      noMatch: "Tidak ada jawaban yang cocok.",
      noResponses: "Belum ada jawaban.",
      who: "Peserta",
      org: "Institusi",
      submitted: "Mengisi",
      merch: "Merchandise",
      submittedAt: "Mengisi {when}, dalam bahasa {lang}",
    },
    liveTitle: "Pertanyaan yang disimpan langsung tayang",
    window: "Survei menerima jawaban dari {opens} sampai {closes} (WIB).",
    noWindow: "Jadwal survei belum diatur.",
    none: "Belum ada pertanyaan. Tambahkan yang pertama di bawah.",
    question: "Pertanyaan {n}",
    moveUp: "Pindah ke atas",
    moveDown: "Pindah ke bawah",
    remove: "Hapus pertanyaan",
    kind: "Jenis",
    kinds: {
      single: "Satu pilihan",
      multiple: "Beberapa pilihan",
      rating: "Nilai 1 sampai 5",
      text: "Jawaban bebas",
    },
    required: "Wajib diisi",
    promptId: "Pertanyaan (Indonesia)",
    promptEn: "Pertanyaan (Inggris)",
    options: "Pilihan jawaban",
    optionId: "Pilihan {n} (Indonesia)",
    optionEn: "Pilihan {n} (Inggris)",
    removeOption: "Hapus pilihan {n}",
    addOption: "Tambah pilihan",
    allowsText: "Minta peserta menyebutkan (untuk Lainnya / Other)",
    ratingHint: "Peserta memilih nilai 1 sampai 5.",
    textHint: "Peserta mengetik jawaban, maksimal 1000 karakter.",
    add: "Tambah pertanyaan",
    forceTitle: "Sudah ada peserta yang mengisi survei ini",
    forceBody:
      "Jawaban mereka tetap tersimpan dengan pertanyaan yang mereka lihat. Siapa pun yang sedang membuka halaman harus memuat ulang sebelum mengirim. Tetap simpan?",
    forceConfirm: "Tetap simpan",
    fixFields: "Ada isian yang perlu diperbaiki; ditandai merah di atas.",
    unsaved: "Ada perubahan yang belum disimpan",
    allSaved: "{n} pertanyaan, semua tersimpan",
    discard: "Batalkan",
    saved: "Pertanyaan survei disimpan",
  },
};
